module.exports = __webpack_public_path__ + "img/frame-data-m.608b1157.png";